import toast from "react-hot-toast";

const server = process.env.REACT_APP_SERVER_URL || "";

export const createPlayground = {
  add: async (formData: any) => {
    try {
      const { designation } = formData;

      const response = await fetch(`${server}/api/playground`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token") ?? ""}`,
        },
        body: JSON.stringify({ designation }),
      });
      const data = await response.json();
      if (response.ok) {
        toast.success("créée avec succès");
        return data;
      } else {
        toast.error("existe déjà");
        throw new Error(response.statusText);
      }
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  },

  verify: async () => {
    try {
      const response = await fetch(`${server}/api/playground`);
      if (!response.ok) {
        throw new Error("Failed to fetch Playground");
      }
      const json = await response.json();
      return json;
    } catch (error) {
      throw error;
    }
  },

  delete: async (id: number) => {
    try {
      const response = await fetch(`${server}/api/playground/${id}`, {
        method: "DELETE",
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || "An error occurred while deleting playground .");
      }
      const res = await response.json();
      toast.success(res.message);
    } catch (error) {
      console.error("error", error);
      // if (error instanceof Error) {
      //   toast.error(error.message);
      // } else {
      //   toast.error("An unexpected error occurred.");
      // }
      throw new Error("Error deleting playground.");
    }
  },
  update: async (data: any, id: any) => {
    try {
      const { designation } = data;

      const response = await fetch(`${server}/api/playground/${id}`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token") ?? ""}`,
        },
        body: JSON.stringify({ designation }),
      });
      const res = await response.json();

      if (response.ok) {
        toast.success(res.msg);
        return res;
      } else {
        // toast.error(res.error);
        throw new Error(response.statusText);
      }
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  },
  getById: async (id: number) => {
    try {
      const response = await fetch(`${server}/api/playground/${id}`, {
        method: "GET",
      });

      if (!response.ok) {
        throw new Error("Failed to delete category");
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Error:", error);
    }
  },

  adminGetAllPlaygrounds: async (page = 1, searchTerm = "") => {
    const query = new URLSearchParams({ page: page.toString() });
    if (searchTerm) {
      query.append("searchTerm", searchTerm);
    }

    const result = await fetch(`${server}/api/admin/playgrounds?${query.toString()}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token") ?? ""}`,
      },
    });

    return result.json();
  },
};
